// extracted by mini-css-extract-plugin
export default {"modal-description":"Modals_modal-description__UiM82","error-message":"Modals_error-message__aD0Ix","input-placeholder":"Modals_input-placeholder__nwF1u"};